// Referral tracking — stores ?ref=CODE in a 30-day cookie and reads it back
const COOKIE_NAME = 'pt_ref';
const COOKIE_DAYS = 30;

export function captureReferral() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('ref');
  if (code && /^[a-zA-Z0-9_-]{1,40}$/.test(code)) {
    const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(code)};expires=${expires};path=/;SameSite=Lax`;
  }
}

export function getReferralCode() {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}
